import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Comprehensive scroll to top function
    const scrollToTop = () => {
      // Method 1: Force immediate scroll to top
      window.scrollTo(0, 0);
      
      // Method 2: Set document scroll positions directly
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      // Method 3: Try modern scrollTo with instant behavior
      try {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant'
        });
      } catch (error) {
        // Fallback already handled above
      }
      
      // Method 4: Force scroll on main element if it exists
      const mainElement = document.querySelector('main');
      if (mainElement) {
        mainElement.scrollTop = 0;
      }
      
      // Method 5: Handle any scrollable containers
      const scrollableElements = document.querySelectorAll('[data-scroll-container]');
      scrollableElements.forEach(element => {
        element.scrollTop = 0;
      });
    };

    // Execute immediately
    scrollToTop();
    
    // Execute after DOM updates (multiple timeouts for reliability)
    const timeouts = [
      setTimeout(scrollToTop, 0),
      setTimeout(scrollToTop, 10),
      setTimeout(scrollToTop, 50),
      setTimeout(scrollToTop, 100)
    ];

    // Also listen for when the page is fully loaded
    const handleLoad = () => scrollToTop();
    window.addEventListener('load', handleLoad);

    // Cleanup function
    return () => {
      timeouts.forEach(timeout => clearTimeout(timeout));
      window.removeEventListener('load', handleLoad);
    };
  }, [pathname]);

  // Also scroll to top when component mounts (initial page load)
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return null;
};

export default ScrollToTopOnRouteChange;
